var NewReview = (function($) { // The parameter imports the JQuery namespace "$".

    var my = {};

    my.countCharacters = function(_event) {
        // Keep counting semantics and limits in sync with Review validation/sanitization in app/models/review.rb.
        const minLength = 100
        const maxLength = 2500
        const len = $(".with-character-counter").val().length

        $(".current-symbols-count").text(len + " tegn ")

        if (len > maxLength) {
            $(".count-symbols").css('color', 'red')
        } else if (len >= minLength) {
            $(".count-symbols").css('color', 'green')
        } else {
            $(".count-symbols").css('color', 'black')
        }
    }

    my.setupSectionToggling = function() {
        $(".togglable").each( function() {
           $(this).click(function(e) {
                if (e.target.tagName.toLowerCase() != "header" && e.target.parentNode.tagName.toLowerCase() != "header") {
                    return;
                }

                $('section.content', $(this)).slideToggle('fast');
                $('.collapse-arrow', $(this)).toggleClass('expanded');

                // When clicking the arrow or box, sometimes a selection is made unintentionally.
                // This workaround removes the selection
                if (window.getSelection) {
                    if (window.getSelection().empty) {  // Chrome
                        window.getSelection().empty();
                    } else if (window.getSelection().removeAllRanges) {  // Firefox
                        window.getSelection().removeAllRanges();
                    }
                } else if (document.selection) {  // IE?
                    document.selection.empty();
                }
            });

            // Support clicking the actual arrow itself.
            // $('.collapse-arrow', $(this)).click(function(e) {
            //    $(this).parents('.togglable').click();
            // });
        });

    }

    my.setupStars = function() {
        $('.stars').each( function() {
            $(this).stars({
                inputType: "select",
                cancelShow: false,
                split: 1,
                captionEl: $('.caption', $(this))}
            )} );
    }

    my.setupConsentInfoDialog = function() {
      /* global DialogUtils */
      $('.health-info-consent a').click(function() {
        DialogUtils.setupDialog($('#health-info-consent-dialog'))
                   .dialog('open');

        return false;
      });
    }

    // Hack to solve the problem that the stars plugin sets its value in a
    // _disabled_ hidden field. ActiveRecord doesn't dig disabled fields.
    my.enableSelectAttributes = function() {
        $(':hidden:disabled').removeAttr('disabled');
    }


    my.setupSelector = function(autocompleteSelector) {
        const hasTextInput = Array.from(autocompleteSelector).some(element =>
            element.querySelector('input[type=text]')
        );

        if (!hasTextInput) {
            return;
        }

        preselectionCount = autocompleteSelector.data('preselection-count')

        setupAutocomplete(autocompleteSelector)

        if (preselectionCount > 1) { // Make the input box a combobox
            setComboboxMode(autocompleteSelector)
        }

        autocompleteSelector.find('.reset').click(function() {
            autocompleteSelector.find("input[type=hidden]").val(null);
            autocompleteSelector.find("input[type=text]").val(null);
            $(this).hide();
            return false;
        });
    }

    function setupAutocomplete(element) {

        $.widget( "custom.autocomplete", $.ui.autocomplete, {
          _renderMenu: function( ul, items ) {
            var self = this;

            var previous_item_in_practice = null;
            $.each( items, function( _index, item ) {
              if (previous_item_in_practice != null && previous_item_in_practice != item.in_practice) {
                ul.append( "<li class='ui-autocomplete-category'><li>" );
              }
              previous_item_in_practice = item.in_practice;

              self._renderItemData( ul, item );
            })
          }
        });

        element.find("input[type=text]").autocomplete({
          delay: 300,
          minLength: 0,
          source: function (request, response) {
            $.ajax({
                url: element.data("source"),
                dataType: "json",
                data: {
                    query: request.term
                },
                success: function (data) {
                    response(data);
                }
            })
          },
          focus: function( _event, _ui ) {
            return false;
          },
          select: function( _event, ui ) {
            // window.location = ui.item.url;
            element.find("input[type=hidden]").val(ui.item.id);
            element.find("input[type=text]").val(ui.item.name);
            return false;
          },
          open: function() {
            inputBoxWidth = $(this.parentNode).find("input[type=text]").outerWidth()
            $(this).autocomplete("widget").outerWidth( inputBoxWidth );
          }
        })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {
            var name = emphasizeMatchingText(item.name, this.term)
            name = appendLocationIfGiven(name, item.location);

            return $( "<li></li>" )
              .data( "item.autocomplete", item )
              .append( "<a>" + name + "</a>" )
              .appendTo( ul )
        };

        element.find("input[type=text]").keypress(function() {
            element.find("input[type=hidden]").val(null);
        }).keyup(function(e) {
            if(e.keyCode == 8) { // Capture backspace
                element.find("input[type=hidden]").val(null);
            }
        });
    }

    function emphasizeMatchingText(string, search_string) {
        var terms_to_emphasize = search_string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1").split(" ");
        terms_to_emphasize = $.grep(terms_to_emphasize, function(n) { return(n) });

        var re = new RegExp(terms_to_emphasize.join("|"), 'ig');
        return string.replace(re,"<em>$&</em>");
    }

    function appendLocationIfGiven(name, location) {
        if (location != null) {
            return name + " (" + location + ")";
        } else {
            return name;
        }
    }

    function setComboboxMode(element) {
        element.addClass("combobox");
        element.parent().find("#combobox-help").show();

        element.append('<button class="button"></button>')
        element.find('button').mousedown(function () {

            input = element.find("input[type=text]");
            // close if already visible
            if (input.autocomplete("widget").is(":visible")) {
                input.autocomplete("close");
            } else {
                input.autocomplete("search", "");
            }

            input.focus();
            return false;
        }).click(function() {
            return false;
        });
    }

    return my;

}(jQuery));

// Make NewReview globally available for legacy code
window.NewReview = NewReview;
